import React from 'react'
import SingleFixture from '../components/Public/FootballAPI/Fixture/SingleFixture'

function SingleFixtureAPIPage() {
    return (
        <div className="bg-light">
            <SingleFixture />
        </div>
        
    )
}
export default SingleFixtureAPIPage